/**
 * Shared gate so a message can never be sent while an agent-selection
 * persist call (single agent via DMModelSelector, or a roster via
 * DMMultiAgentSelector) is still in flight or queued.
 *
 * Without this, clicking a new agent and immediately hitting Send races the
 * `setAgentOnUser` request: the message can reach the backend before that
 * request lands, so `resolve_user_agent_config` (mcp_management.py) still
 * returns the PREVIOUS selection — the agent actually used silently
 * disagrees with what the UI already shows as selected. Chaining every
 * persist call through `queueAgentSelectionPersist` and having the composer
 * await `waitForPendingAgentSelection` before sending closes that gap, and
 * as a side effect also serializes rapid repeated toggles (e.g. checking two
 * roster boxes quickly) so they always land at the server in click order.
 */
let chain: Promise<void> = Promise.resolve();

export function queueAgentSelectionPersist<T>(fn: () => Promise<T>): Promise<T> {
    const result = chain.then(fn, fn);
    chain = result.then(
        () => undefined,
        () => undefined
    );
    return result;
}

export function waitForPendingAgentSelection(): Promise<void> {
    return chain;
}
